var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wrap-container',[_c('select-options',{attrs:{"label":"Producto","title":"¿Sobre qué producto querés realizar una solicitud?"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }